module.exports = __webpack_public_path__ + "img/login.a367931e.jpg";